<template>
  <FlotoCrudContainer
    prepend-new-item
    :fetch-fn="getAnnouncements"
    as-table
    hide-table-headers
    :columns="columns"
  >
    <template v-slot:add-controls="{ refreshList }">
      <FlotoPageHeader
        use-divider
        :back-link="backLink"
        :title="$tc('announcement', 2)"
      />
      <MRow :gutter="0" class="my-2">
        <MCol :size="12">
          <FlotoSearchBar
            ref="searchBar"
            :allow-save-search="false"
            :persist-criteria="false"
            :module-name="moduleName"
            :exclude-search-params="announcementListExcludeSearchParams"
            prevent-supported-api
            @change="applyCriteria($event, refreshList)"
          />
        </MCol>
      </MRow>
    </template>
    <template v-slot:form-header>
      <div class="flex items-center">
        <MIcon name="bullhorn" size="lg" class="mr-2" />
        {{ $tc('announcement') }}
      </div>
    </template>
    <template v-slot:form-items="{ item: announcement }">
      <FlotoFixedView>
        <AnnouncementView :announcement="announcement" />
      </FlotoFixedView>
    </template>
    <template v-slot:form-actions="{ cancel }">
      <MButton variant="default" class="ml-2" @click="cancel">
        {{ $t('close') }}
      </MButton>
    </template>
    <template v-slot:name="{ item, edit }">
      <td class="resource-link">
        <a @click="edit">
          <ResourceListTitle
            :subject="item.name"
            :created-at="item.updatedAt"
            v-bind="showOwner ? { requesterName: (item.owner || {}).name } : {}"
          />
        </a>
      </td>
    </template>
  </FlotoCrudContainer>
</template>

<script>
import AnnouncementView from './announcement-view'
import ResourceListTitle from '@components/resource/resource-list-title'
import { TechnicianComputed } from '@state/modules/technician'
import { announcementListExcludeSearchParams } from '@components/search/sources'
export default {
  name: 'AnnouncementList',
  components: { AnnouncementView, ResourceListTitle },
  props: {
    fetchFn: { type: Function, required: true },
    backLink: { type: Object, default: undefined },
    showOwner: { type: Boolean, default: false },
  },
  data() {
    this.announcementListExcludeSearchParams =
      announcementListExcludeSearchParams
    this.columns = [{ key: 'name' }]
    this.moduleName = this.$constants.ANNOUNCEMENT
    return {
      searchCriterias: {
        quals: [],
        type: 'FlatQualificationRest',
      },
    }
  },
  computed: {
    ...TechnicianComputed,
  },
  methods: {
    owner(id) {
      return this.technician(id)
    },
    getAnnouncements(limit, offset) {
      return this.fetchFn(this.searchCriterias, limit, offset).then((data) => {
        return {
          ...data,
          items: data.items.map((x) => ({
            ...x,
            owner: this.owner(x.createdBy),
          })),
        }
      })
    },
    applyCriteria(searchCriteria, refreshList) {
      this.searchCriterias = searchCriteria
      refreshList()
    },
  },
}
</script>
